<template>
	<div class="scroll"></div>
</template>

<script>
	export default {

    data(){
      return {
        scrollTop : 0,
        documentScrollHeight : 0,
        getWindowHeight : 0,
        key : true
      }
    },
		name:'Scroll',
		methods:{
			scrollEvent(){
        this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset ;
        this.documentScrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        this.getWindowHeight =  document.documentElement.clientHeight

        // console.log(this.scrollTop + this.getWindowHeight);
        // console.log(this.documentScrollHeight);


        // if(navigator.userAgent.toLowerCase().match(/huawei/i) == "huawei"){
        //   if (this.scrollTop
        //              + this.getWindowHeight + 100
        //            > this.documentScrollHeight ) {
        //       this.onBottom();
        //   }
        // }else{
        //   if (this.scrollTop
        //              + this.getWindowHeight
        //             == this.documentScrollHeight ) {
				// 	this.onBottom();
				// }
        // }
        if (this.scrollTop
                     + this.getWindowHeight + 100
                   > this.documentScrollHeight && this.key) {
              this.key = false
              this.onBottom(()=>{
                this.key = true
              });
          }

			}
		},
		props:{
			onBottom:Function
		},
		mounted(){
      // console.log(1)
      setTimeout(() => {
        window.addEventListener('scroll', this.scrollEvent,false);
      }, 100);
		},
		destroyed () {
      window.removeEventListener('scroll', this.scrollEvent,false);
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/scroll.vue